import { Result } from 'antd';
import { createContext, ErrorInfo, useContext } from 'react';
import {
    ErrorBoundary,
    FallbackProps,
    useErrorBoundary,
} from 'react-error-boundary';

interface ErrorAllContextProps {
    showError: (error: Error) => void;
}

interface ErrorAllProviderProps {
    children: React.ReactNode;
}

const ErrorAllContext = createContext<ErrorAllContextProps | undefined>(
    undefined
);

export const ErrorAllProvider = ({ children }: ErrorAllProviderProps) => {
    const onError = (err: Error, info: ErrorInfo) => {
        console.error('ErrorBoundary', err.message, info);
    };

    const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
        setTimeout(() => {
            resetErrorBoundary();
        }, 10000);

        return (
            <div role="alert">
                <Result
                    status="error"
                    title="Failed"
                    subTitle={error.message}
                />
            </div>
        );
    };
    const showError = (error: Error) => {
        // console.error('ErrorBoundary', error.message || '');
    };
    return (
        <ErrorBoundary FallbackComponent={Fallback} onError={onError}>
            <ErrorAllContext.Provider value={{ showError }}>
                {children}
            </ErrorAllContext.Provider>
        </ErrorBoundary>
    );
};

export const useErrorAll = () => {
    const context = useContext(ErrorAllContext);
    if (context === undefined) {
        throw new Error(
            'useErrorAll must be used within a ErrorBoundaryProvider'
        );
    }
    return context;
};
